import { signOut } from 'firebase/auth';
import { PillButton } from '@ab-platform/ui/pill-button';
import { useAuth } from '@/auth/AuthGate';
import { getFirebaseAuth, isEmulatorMode } from '@/auth/firebase';

/**
 * Operational header — only rendered inside the authenticated subtree
 * (AuthShell → AuthGate's children), so `useAuth` is always available
 * here. Wears the email + role chip plus a minimal "Esci" action that
 * delegates to Firebase `signOut`. After sign-out the AuthGate
 * observer fires, the gate flips to `unauthenticated`, and the
 * unauthenticated branch redirects to `/login` — no client-side
 * navigation here, the gate is the source of truth.
 */
export function Header(): JSX.Element {
  const { user, claims } = useAuth();
  const role = typeof claims['role'] === 'string' ? (claims['role'] as string) : 'unknown';

  return (
    <header className="flex h-14 items-center justify-between border-b border-border bg-card px-6">
      <div className="text-sm font-medium text-foreground">Intermediari (stand-by)</div>
      <div className="flex items-center gap-3 text-xs text-muted-foreground">
        {isEmulatorMode ? (
          <span className="rounded-md bg-state-warning px-2 py-0.5 font-medium text-state-warning-foreground">
            AUTH MODE: emulator — role: {role}
          </span>
        ) : null}
        <span>{user?.email ?? '—'}</span>
        <PillButton
          type="button"
          variant="ghost"
          size="sm"
          onClick={() => {
            const auth = getFirebaseAuth();
            if (auth) void signOut(auth);
          }}
        >
          Esci
        </PillButton>
      </div>
    </header>
  );
}
